/*
* Toggling Mobile and Desktop
*/
export default function (mobileValue, desktopValue) {
  let obj = this
  obj.isMobile = -1
  obj.mobileCallbacks = []
  obj.desktopCallbacks = []
  obj.mobileMedia = undefined
  obj.desktopMedia = undefined

  /* Check mobile on resize */
  obj.resized = function()	{
		if ((obj.isMobile === -1 || !obj.isMobile) && 'matchMedia' in window && window.matchMedia(obj.mobileMedia).matches) {
			obj.isMobile = true
      obj.callMobile()
      $(window).trigger('toggle')
		} else if ((obj.isMobile === -1 || obj.isMobile) && 'matchMedia' in window && window.matchMedia(obj.desktopMedia).matches) {
			obj.isMobile = false
      obj.callDesktop()
      $(window).trigger('toggle')
		}
	}

  /* Call callbacks */
  obj.callMobile = function() {
    obj.mobileCallbacks.forEach(function(callback) {
      callback()
    })
  }

  obj.callDesktop = function() {
    obj.desktopCallbacks.forEach(function(callback) {
      callback()
    })
  }

  /* Add callbacks */
  obj.addCallbacks = function(_mobileCallback, _desktopCallback, _autoRun) {
    obj.mobileCallbacks.push(_mobileCallback)
    if (_desktopCallback == undefined) {
      _desktopCallback = function() {}
    }
    obj.desktopCallbacks.push(_desktopCallback)
    if (_autoRun === undefined || _autoRun == true) {
      if (obj.isMobile === true) {
        _mobileCallback()
      } else if (obj.isMobile === false) {
        _desktopCallback()
      }
    }
    return obj
  }
  obj.add = function(_mobileCallback, _desktopCallback, _autoRun) {
    return obj.addCallbacks(_mobileCallback, _desktopCallback, _autoRun)
  }

  obj.matchesMedia = function() {
    return obj.isMobile
  }

  obj.kill = function() {
    obj.mobileCallbacks = []
    obj.desktopCallbacks = []
    $(window).off('resize orientationchange load', obj.resized)
  }

  /* Initializer */
  if (mobileValue == undefined) {
    mobileValue = 767
  }
  if (typeof mobileValue == 'number') {
    obj.mobileMedia = '(max-width: ' + mobileValue + 'px)'
    obj.desktopMedia = '(min-width: ' + (mobileValue + 1) + 'px)'
  } else if (typeof mobileValue == 'string') {
    obj.mobileMedia = mobileValue
    obj.desktopMedia = desktopValue
  }
  $(window).on('resize orientationchange load', obj.resized)
  obj.resized()
  return obj
}
